import React, { useEffect, useState } from "react";
import { Button, MenuItem, Select, TextareaAutosize } from "@material-ui/core";
import { compose } from "redux";
import amlConnector from "../../../services/aml/amlConnector";
import { usersConnector } from "../../../services/users/connectors/Users.Connector";
import AmlTableComponent from "./AmlExtras/Aml.Table.Component";
import { effectiveRiskLevel } from "../../../shared/dictionary/enums";
import AmlDepositsTableComponent from "./AmlExtras/Aml.Deposits.Table.Component";

const UserAmlNotesComponent = ({
  currentDomain,
  investorNotes,
  getInvestorDepositAmlWarnings,
  amlWarnings,
  borrowerNotes,
  amlProfile,
  users,
  setInvestorAmlRiskLevel,
  setBorrowerAmlRiskLevel,
  getInvestorAmlNotes,
  getBorrowerAmlNotes,
}) => {
  const currentUser = users.currentUser.Id;
  const [selectValue, changeSelectValue] = useState(getCurrentRiskLevel);
  const [noteValue, changeNoteValue] = useState("");
  const isNoteFilled = noteValue.length < 5;
  const notes =
    currentDomain === "Loanstep"
      ? borrowerNotes[currentUser]
      : investorNotes[currentUser];

  useEffect(() => {
    if (currentDomain === "Loanstep") getBorrowerAmlNotes(currentUser);
    if (currentDomain === "Savelend") {
      getInvestorAmlNotes(currentUser);
      getInvestorDepositAmlWarnings(currentUser);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDomain, currentUser]);

  return (
    <React.Fragment>
      <div className="display-flex">
        <div style={{ marginRight: "15px" }}>
          <div>Choose risk level</div>
          <Select
            onChange={(event) => changeSelectValue(event.target.value)}
            value={selectValue}
          >
            <MenuItem value={effectiveRiskLevel.Low}>
              {effectiveRiskLevel.Low}
            </MenuItem>
            <MenuItem value={effectiveRiskLevel.Normal}>
              {effectiveRiskLevel.Normal}
            </MenuItem>
            <MenuItem value={effectiveRiskLevel.High}>
              {effectiveRiskLevel.High}
            </MenuItem>
            <MenuItem value={effectiveRiskLevel.Unacceptable}>
              {effectiveRiskLevel.Unacceptable}
            </MenuItem>
          </Select>
        </div>
        <div style={{ marginRight: "15px" }}>
          <div>Fill in the note</div>
          <TextareaAutosize
            style={{ marginTop: "5px" }}
            className="text-area"
            rowsMin="6"
            placeholder="Note"
            onChange={(event) => changeNoteValue(event.target.value)}
          />
        </div>
        <Button
          style={{ marginTop: "27px" }}
          variant="contained"
          color="primary"
          className="button-confirm"
          disabled={isNoteFilled}
          onClick={updateNotes}
        >
          Confirm
        </Button>
      </div>
      <div>
        <AmlTableComponent notes={notes} />
      </div>
      <div>
        <h3>AML Flagged Investor Deposits</h3>
        <AmlDepositsTableComponent data={amlWarnings.personalData} />
      </div>
    </React.Fragment>
  );

  function FormatNote() {
    let note = "From: ";
    note =
      note + getCurrentRiskLevel() + " to: " + selectValue + ", " + noteValue;
    return note;
  }

  function updateNotes() {
    const note = FormatNote();
    if (currentDomain === "Loanstep") {
      setBorrowerAmlRiskLevel(selectValue, note, currentUser);
    }
    if (currentDomain === "Savelend") {
      setInvestorAmlRiskLevel(selectValue, note, currentUser);
    }
  }

  function getCurrentRiskLevel() {
    return amlProfile[currentUser].data.EffectiveRiskLevel;
  }
};

export default compose(amlConnector, usersConnector)(UserAmlNotesComponent);
